export default "__VITE_ASSET__D$ErBV_7__"